import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'mycampapp-faq',
	templateUrl: './faq.component.html',
	styleUrls: ['./faq.component.less']
})
export class FaqComponent implements OnInit
{

	constructor() { }

	ngOnInit()
	{
	}

}
